/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 6.1.6
* 
*******************************************************************************/
import { uppercaseSingleButton, backspaceSingleButton, spaceFourspaceButton, clearDoublespaceButton, layoutLettersButton, layoutSymbolsActiveButton, dotnetButton, dotcomButton } from '../sharedSpecialKeys';
var CHAR_CODE_ZERO = 48;
var CHAR_CODE_ONE = 49;
var FEATURE_KEY = {
  DOTCOM: dotcomButton,
  DOTNET: dotnetButton,
  UPPERCASE: uppercaseSingleButton,
  BACKSPACE: backspaceSingleButton,
  LAYOUT2: layoutSymbolsActiveButton,
  LAYOUT1: layoutLettersButton,
  SPACE: spaceFourspaceButton,
  CLEAR: clearDoublespaceButton
};
var textArray = Array.from(new Array(9), function (x, index) {
  return String.fromCharCode(CHAR_CODE_ONE + index);
}).concat(Array.from(new Array(1), function (x, index) {
  return String.fromCharCode(CHAR_CODE_ZERO + index);
})).concat(['-', '/', ':', ';', '[', ']', '*', '%', '<', '>', '_', '|', '#', '+', '=', '?', '!', '.', "'", '{', '}', '&', '"', ' ,']).concat(Object.entries(FEATURE_KEY).map(function (obj) {
  return obj[1].text;
}));
export { textArray, FEATURE_KEY };